export default __webpack_public_path__ + "static/media/sales.16fee8a0.svg";